import { ListaSolicitacoes } from '@/components/PagesComponents/ListaSolicitacoes';


const ListarSolicitacoesPosGraduacao = () => {
    return(
        <>
            <h1>Pós-Graduação - Solicitações</h1>

            <ListaSolicitacoes />
            
        </>
    );
}

export { ListarSolicitacoesPosGraduacao };